import { Space } from 'antd';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import { TelegramAccountProps } from 'features/user/interfaces';

import { Settings } from '../Settings';
import { AddTelegramAccount } from './components/AddTelegramAccount';
import { TelegramAccount } from './components/TelegramAccount';

type TProps = {
    accounts: Array<TelegramAccountProps>;
    isAccountPrimary: boolean;
};

export const TelegramAccounts: React.FC<TProps> = props => {
    return (
        <Settings
            title='Telegram'
            error={!props.accounts.length}
            description='Создание магазина будет доступно после привязки Telegram.'
        >
            <Fragment>
                {!!props.accounts.length && (
                    <Wrapper>
                        {props.accounts.map((account, index) => (
                            <TelegramAccount {...account} key={index} />
                        ))}
                    </Wrapper>
                )}
                <StyledActions wrap>
                    <AddTelegramAccount
                        isAccountPrimary={props.isAccountPrimary}
                    />
                </StyledActions>
            </Fragment>
        </Settings>
    );
};

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 8px;
`;

const StyledActions = styled(Space)`
    display: flex;
    gap: 16px;
`;
